import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {Router} from '@angular/router';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {ResponseLoginDto} from "./containers/sso-redirect/DTO/response-login.dto";

@Injectable({ providedIn: 'root' })
export class AuthService {
  public currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  loginWithSSO(token: string) {
    return this.http.post<ResponseLoginDto>(`${environment.apiBaseUrl}/token/validate`, {token});
  }


  login(body: any) {
    return this.http.post<any>(`${environment.apiBaseLogin}/login`, body)
      .pipe(map(user => {
        // sso-redirect successful if there's a jwt token in the response
        if (user && user.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          user = {...user, phone: body.username};
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }
        return user;
      }), catchError(err => {
        return throwError(err);
      }) );
  }

  logout() {
    if (this.currentUserValue != null) {
      // tslint:disable-next-line:variable-name
      const header_object = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.currentUserValue.token
      });
      const httpOptions = {
        headers: header_object
      };
      localStorage.removeItem('currentUser');
      localStorage.removeItem('fireBaseToken');
      // localStorage.setItem('action', 'logout');
      this.currentUserSubject.next(null);
      this.router.navigate(['']);
      return this.http.get<any>(`${environment.apiBaseUrl}/user/logout`, httpOptions).subscribe();
    } else {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('fireBaseToken');
      this.currentUserSubject.next(null);
      this.router.navigate(['']);
    }
  }

  getOtp(phone: any) {
    return this.http.get<any>(`${environment.apiBaseUrl}/user/resetpassword?phone=` + phone);
  }
  sendOtp(body: any) {
    return this.http.put<any>(`${environment.apiBaseUrl}/user/resetpassword`, body);
  }

  linkAcc(tokenLink: any, body: any) {
    return this.http.put<any>(`${environment.apiBaseUrl}/user/link?token=${tokenLink}`, body);
  }
}
